import React from 'react'
import PropTypes from 'prop-types'

const BurgerIcon = ({ active, className, ...props }) => (
  <svg
    viewBox={active ? '0 0 32 26' : '0 0 22 16'}
    className={className}
    {...props}
  >
    <path
      className='transition duration-700'
      stroke={active ? '#01DD93' : 'currentColor'}
      strokeLinecap='round'
      strokeWidth='1.5'
      d={active ? 'M0.75 -0.75L33.689 -0.75' : 'M0.75 1.25L21.25 1.25'}
      transform={
        active ? 'scale(-1.0066 -.99336) rotate(45 15.233 -46.369)' : ''
      }
    />

    <path
      className='transition duration-700'
      stroke={active ? 'transparent' : 'currentColor'}
      strokeLinecap='round'
      strokeWidth='1.5'
      d='M0.75 8.25L21.25 8.25'
      transform={active ? 'translate(100 0)' : 'translate(0 0)'}
    />

    <path
      className='transition duration-700'
      stroke={active ? '#01DD93' : 'currentColor'}
      strokeLinecap='round'
      strokeWidth='1.5'
      d={active ? 'M0.75 -0.75L33.689 -0.75' : 'M0.75 15.25L21.25 15.25'}
      transform={active ? 'matrix(.71177 -.7024 .71177 .7024 4 25.506)' : ''}
    />
  </svg>
)

export default BurgerIcon

BurgerIcon.propTypes = {
  active: PropTypes.bool,
  className: PropTypes.string
}

BurgerIcon.defaultProps = {
  active: false,
  className: ''
}
